import { store } from "~/state/store";
import { ESETTINGS_KEYS, IUserSpeedData } from "~/state/user/interfaces";
import { DEFAULT_VALUE_USER_SPEED } from "~/util/constants";

export function timeWithUserSpeed(time: number, criterion: number) {
	const user = store.getState().user;
	let userTime = time;

	if (user.user.premium) {
		const { settings } = user;
		const userSpeedSettings = (settings.find(item => item.title === ESETTINGS_KEYS.ROUTING_CRITERION_SPEED)?.data?.value) as IUserSpeedData || {};

		if (userSpeedSettings?.[criterion] && DEFAULT_VALUE_USER_SPEED[criterion]) {
			const multiplier = DEFAULT_VALUE_USER_SPEED[criterion].value / userSpeedSettings[criterion.toString()].value;

			userTime = Math.round(time * multiplier);
		}
	}

	return userTime;
}
